import { Alert } from "@components/ui/Alert";
import { Paragraph } from "@components/ui/Paragraph";
import { ShowMore } from "@components/ui/ShowMore";
import { Title } from "@components/ui/Title";
import { TourByIdQuery } from "@graphql/types";
import { Trans } from "@helpers/translate";
import React, { FC, Fragment } from "react";

interface Props {
  tour: NonNullable<TourByIdQuery["tourById"]>;
}

export const Important: FC<Props> = ({ tour }) => {
  if (
    tour.important === "" &&
    tour.supplier.important === "" &&
    tour.conditions === ""
  ) {
    return <Fragment />;
  }

  return (
    <div className="mb-20">
      <Title as="h2" size="md" divider>
        <Trans id="tour.block.important.title">
          Tour Important Information
        </Trans>
      </Title>

      <ShowMore className="mb-4">
        <Paragraph>{tour.important}</Paragraph>
      </ShowMore>

      {tour.conditions && (
        <Paragraph size="sm" className="mb-20">
          {tour.conditions}
        </Paragraph>
      )}

      {tour.supplier.important && tour.supplier.important.trim().length > 0 && (
        <>
          <Title as="h2" size="md" className="mt-10 mb-2">
            <Trans id="tour.block.important.guide-message">
              Important message from the supplier
            </Trans>
          </Title>
          <Alert className="mb-6">
            {tour.supplier.important && (
              <Paragraph size="sm">{tour.supplier.important}</Paragraph>
            )}
          </Alert>
        </>
      )}
    </div>
  );
};
